import React, { Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import PageNotFound from "../Components/ErrorHandler/PageNotFound";
import { Spin } from "antd";
import ProtectedLayout from "./ProtectedLayout";
import GlobalLayout from "./GlobalLayout";
import { ProtectRoutes, GlobalRoutes } from "./Routes";
import MyStore from "../Pages/CommonPages/MyStore";
import { isAllowed } from "../Utils/consent";
export default function MainLayout() {
  const location = useLocation();

  // Track PageView on every route change (Meta Pixel — gated on ad consent)
  useEffect(() => {
    if (isAllowed("advertising") && window.fbq && window.currentMetaPixelId) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  // Scroll to top on route change (pathname only — NOT search, so listing-page
  // filter changes that mirror into the query string don't jump the page).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const getElementWithAccess = (element) => {
    return element;
  };

  return (
    // <Suspense fallback={<Skeleton loading={true} active className="my-3" />}>
    <Suspense
      fallback={
        <div className="flex justify-center items-center min-h-screen">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<MyStore />} />
        {/* <Route path="/:id" element={<CheckOrder />} /> */}
        <Route element={<ProtectedLayout />}>
          {ProtectRoutes.map(({ path, element, roles }) => (
            <Route
              path={path}
              element={getElementWithAccess(element, roles)}
              key={path}
            />
          ))}
        </Route>
        <Route element={<GlobalLayout />}>
          {GlobalRoutes.map(({ path, element, ...res }) => (
            <Route path={path} {...res} element={element} key={path} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
}
